import {
  ADJUSTER_REPORT_BASE_PATH,
  FILE_DETAIL_BASE_PATH,
} from '@/config/baseModulesLink.tsx';

export const QUERY_PARAMS = {
  sendOfflinePhotos: 'damagedId',
};

export const FILE_DETAIL_LINKS = {
  detail: (id: number) => `/${FILE_DETAIL_BASE_PATH}/${id}`,
  adjusterReport: (id: number) => `/${ADJUSTER_REPORT_BASE_PATH}/${id}`,
  information: 'information',
  documentation: 'documentation',
  statusTransition: 'status-transition',
  actions: 'actions',
};
